import React, { useCallback, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { toast } from 'react-toastify';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';

import SimpleHeader from 'components/Headers/SimpleHeader.js';
import Loader from 'components/Loader';

import ProductService from '../../services/productService';
import { toBrazilianFullDate } from 'views/CRM/shared/utils/date';
import ProductInputs from '../FormInputs';
import { Attachments } from 'views/CRM/shared/components/UploadAttachments';

const sectionStyle = {
  backgroundColor: '#f7f7f7',
  padding: '0.8rem 1rem',
  borderRadius: '0.1rem'
};

const ProductDetails = () => {
  const history = useHistory();
  const { recordTypeId, id } = useParams();

  const [product, setProduct] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const getProduct = useCallback(() => {
    setIsLoading(true);
    ProductService.getById(id)
      .then((response) => {
        setProduct(response.data.data);
      })
      .catch(() => {
        toast.error('Ocorreu um erro ao buscar informações do produto');
        backToProductListing();
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [backToProductListing, id]);

  useEffect(() => {
    getProduct();
  }, [getProduct]);

  // const reloadProduct = useCallback(() => {
  //   getProduct();
  // }, [getProduct]);

  const backToProductListing = useCallback(() => {
    history.push('/admin/crm/products', { recordTypeId });
  }, [recordTypeId, history]);

  if (isLoading) {
    return (
      <Row className="justify-content-md-center">
        <Loader />
      </Row>
    );
  }

  if (!product) return null;

  return (
    <>
      <SimpleHeader
        name="Product edit"
        parentName="Product"
        returnPath="/admin/crm/products"
        navigatorState={{ recordTypeId }}
      />
      <Container className="configuration-container mt--6" fluid>
        <Card>
          <CardBody>
            <Row className="mb-3">
              {/* <Col sm="3">
                <h3 className="font-weight-bold small mb-0">Criado por:</h3>
                <span>{account.createdByName}</span>
              </Col> */}
              <Col sm="3">
                <h3 className="font-weight-bold small mb-0">Criado em:</h3>
                <span>{toBrazilianFullDate(product.createdAt)}</span>
              </Col>
              {/* <Col sm="3">
                <h3 className="font-weight-bold small mb-0">
                  Última modificação por:
                </h3>
                <span>{product.lastUpdatedByName}</span>
              </Col> */}
              <Col sm="3">
                <h3 className="font-weight-bold small mb-0">
                  Última modificação em:
                </h3>
                <span>{toBrazilianFullDate(product.updatedAt)}</span>
              </Col>
            </Row>

            <hr style={{ margin: '0', paddingTop: '0' }} />

            <div className="mt-3" style={sectionStyle}>
              <h2>Dados do Produto</h2>
              <ProductInputs
                recordTypeId={recordTypeId}
                product={product}
                showCallIconOnPhoneField={false}
                showMessageIconOnPhoneField={false}
              />
            </div>

            <Row style={{ paddingTop: '20px', paddingBottom: '40px' }}>
              <Col>
                <h3 className="form-control-label mt-2">Anexo(s)</h3>
                <Attachments
                  isFromProduct={true}
                  entityId={product?.id}
                  attachments={product?.attachments}
                  isButtonDisabled={product?.isConverted}
                  onAdded={(addedAttachments) => {
                    setProduct((prev) => ({
                      ...prev,
                      attachments: [...prev.attachments, ...addedAttachments]
                    }));
                  }}
                  onDeleted={(attachmentId) => {
                    const remainAttachments = product.attachments.filter(
                      (att) => att.id !== attachmentId
                    );
                    setProduct((prev) => ({
                      ...prev,
                      attachments: remainAttachments
                    }));
                  }}
                  entityService={ProductService}
                />
              </Col>
            </Row>

            {/* <div className="mt-3" style={sectionStyle}>
              <div className="d-flex justify-content-between mb-2">
                <h2>Contatos ({product?.contacts?.length || 0})</h2>
                <AddContactModal
                  accountId={id}
                  onAddedContact={reloadAccount}
                  buttonOpenModal={({ onClick }) => (
                    <Button size="sm" onClick={onClick}>
                      Adicionar
                    </Button>
                  )}
                />
              </div>

              <AccountContacts
                contacts={account.contacts}
                accountId={id}
                reloadAccount={reloadAccount}
              />
            </div> */}
            {/* <div className="mt-3" style={sectionStyle}>
              <div className="d-flex justify-content-between mb-2">
                <h2>Oportunidades ({account?.opportunities?.length || 0})</h2>
                <AddOpportunityModal
                  accountId={id}
                  onAddedOpportunity={reloadAccount}
                  buttonOpenModal={({ onClick }) => (
                    <Button size="sm" onClick={onClick}>
                      Adicionar
                    </Button>
                  )}
                />
              </div>

              <AccountOpportunities
                opportunities={account.opportunities}
                reloadAccount={reloadAccount}
              />
            </div> */}

            {/* <div className="mt-3" style={sectionStyle}>
              <h2>{`Protocolos (${account?.protocols?.length || 0})`}</h2>
              <AccountProtocols protocols={account?.protocols} />
            </div> */}
          </CardBody>
        </Card>
      </Container>
    </>
  );
};

export default ProductDetails;
